/* eslint-disable no-extra-boolean-cast */
import { createContact } from '@src/reducers/contactVCard';
import { defaultStandardBotIdSelector } from '@src/selectors/preferences';
import { RootState } from '@src/store/reduxstore';
import {
  ChatMessageContactPhone,
  ChatMessageContact as MessageContact,
} from '@src/types';
import { ResponseStatus } from '@src/types/chats';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import useContactUtils from '../hooks/useContactUtils';
import ChatMessageContactBtn from './ChatMessageContactBtnStyle';

export type ChatMessageContactSaveProps = {
  contact: MessageContact;
  activePhone: ChatMessageContactPhone;
  onContactSave: () => void;
};

const ChatMessageContactSave: React.FC<ChatMessageContactSaveProps> = ({
  contact,
  activePhone,
  onContactSave,
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { formatContactPhone } = useContactUtils();
  const botId = useSelector(defaultStandardBotIdSelector);

  const createContactState = useSelector(
    (state: RootState) => state.contactVCard.createContact
  );

  const onClickSaveBtn = () => {
    const mobilePhoneNumber = activePhone.wa_id || activePhone.phone || '';
    const mobileNumber = formatContactPhone(mobilePhoneNumber);

    dispatch(
      createContact({
        contact: {
          address: !!contact?.addresses?.length
            ? contact.addresses[0].street
            : '',
          identificationNumber: '',
          company: contact.company?.company || '',
          email: !!contact?.emails?.length ? contact.emails[0].email : '',
          fullName: contact?.name?.last_name
            ? `${contact.name.first_name} ${contact.name.last_name}`
            : contact.name.first_name,
          mobileNumber,
        },
        botId,
      })
    );
  };

  useEffect(() => {
    const contactPhone = formatContactPhone(
      activePhone?.wa_id ?? activePhone.phone
    );

    if (
      activePhone &&
      createContactState?.status === ResponseStatus.SUCCESS &&
      createContactState?.key === contactPhone
    )
      onContactSave();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePhone, createContactState]);

  return (
    <ChatMessageContactBtn type="button" onClick={onClickSaveBtn}>
      {formatMessage({ id: 'Console.ContactMessage.Save' })}
    </ChatMessageContactBtn>
  );
};

export default ChatMessageContactSave;
